import { useEffect } from 'react'

const useDocumentTitle = title => {
  useEffect(() => {
    document.title = `${title} - Testing Platform`
  })
}

export default useDocumentTitle
